/* eslint-disable complexity */

const UploadDocument = () => import(/* webpackChunkName: "UploadDocument" */ '@/components/upload-document');

export default {
    name: 'yuri-boleta',

    props: {
        section: {
            default: 'operation',
            type: String
        },
        id: {
            required: true,
            type: String
        }
    },

    components: {
        UploadDocument
    },

    /**
     * @override
     */
    data() {
        return {
            docs: [],
            loading: true,
            uploadDocument: false
        };
    },
    methods: {
        /**
         * @override
         */
        fetch() {
            const cfg = {};
            cfg.params = {};
            if (this.limit) {
                cfg.params.$limit = this.limit;
            }
            this.$operationsService.getOperationDocuments(this.id, cfg)
                .then(res => {
                    this.docs = res.data.operations_documents || [];
                    setTimeout(() => this.loading = false, 500);
                });

        },

        /**
         * Link a documento
         * @param {String} uuid_document id del documento
         * @param {String} fileName nombre del documento
         */
        linkDocument(uuid_document, fileName) {
            if (this.section === 'operation') {
                this.$operationsService.getDocument(this.id, uuid_document)
                    .then(res => {
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(res);
                        link.download = fileName;
                        document.body.append(link);
                        link.click();
                        link.remove();
                        window.addEventListener('focus', () => URL.revokeObjectURL(link.href), { once: true });
                    });
            } else {
                console.warn('TODO: Implementar descarga aquí para esta sección');
            }
        },

        /**
         * SUBIDA ARCHIVOS CORRECTA
         * Método llamado al lanzar el emit desde el componente upload-documents
         */
        uploadOk() {
            this.uploadDocument = false;
            this.fetch();
        }
    },

    computed: {
        /**
         * @override
         */
        boleta() {
            // TODO: Revisar esto cuando las categorías/subcategorías de operaciones estén definidas
            return this.docs.filter( e => e.key_category === 'OPERATION' ).sort((e, e1) => new Date(e1.created_on) - new Date(e.created_on));
        }
    },

    /**
     * @override
     */
    beforeMount() {
        this.fetch();
    }

};
